
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/referenzen/referenzen-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="referenzen-view">
        <hero-section
            background-image="/images/hero/referenzen-hero.jpg"
            headline="Unsere Referenzen"
            subheadline="Referenzen von FASE2"
            text="<strong>Zufriedene Kunden sind unsere beste Visitenkarte.</strong><br>Werfen Sie einen Blick auf unsere erfolgreich abgeschlossenen Projekte und lassen Sie sich überzeugen."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="profil-cleanodino">
                <p>
                    Aktuell bereiten wir eine Auswahl aussagekräftiger Projekte für Sie auf. In Kürze finden Sie hier Einblicke in unsere Arbeit, die zeigt, was möglich ist, wenn Erfahrung auf Innovation trifft.<br><br>

                    <b>Schauen Sie bald wieder vorbei – es lohnt sich.</b>
                </p>
            </article>
        </div>
    </section>`,
      style: `referenzen-view .referenzen-view {
  margin: 0;
  padding: 0;
}
referenzen-view .referenzen-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
referenzen-view .referenzen-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
referenzen-view .referenzen-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  referenzen-view .referenzen-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  